export const common = {
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.close': 'Close',
    'common.delete': 'Delete',
    'common.remove': 'Remove',
    'common.rename': 'Rename',
    'common.back': 'Back',
    'common.moment': 'One moment …',
    'common.loading': 'Loading …',
    'common.name': 'Name',
    'common.email': 'Email',
    'common.password': 'Password',
    'common.organisation': 'Organisation',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.copy': 'Copy',
    'common.copied': 'Copied',
    'common.apply': 'Insert',
    'common.unknownPerson': 'Unknown person',
    'common.none': 'None',
    'common.person.one': '{count} person',
    'common.person.many': '{count} people',
    'common.day.one': '{count} day',
    'common.day.many': '{count} days',
    'common.footer': 'Præsto — a tool by',
    'legal.start': 'Home',
    'legal.imprint': 'Imprint',
    'legal.privacy': 'Privacy',
    'common.language': 'Language',
    'update.notice': 'Præsto has been updated. This tab is still running the old version — please reload, otherwise inserting content may fail.',
    'update.reload': 'Reload',
    'error.requestFailed': 'Request failed ({status})',
};
//# sourceMappingURL=common.js.map